import { hasBillPayAccess } from '@auth/has-bill-pay-access'
import { useAuth } from '@auth/use-auth'

export const RequireBillPay = ({ children, fallback }) => {
  const auth = useAuth()

  return hasBillPayAccess(auth) ? children : fallback
}
